module.exports = __webpack_public_path__ + "static/media/Inter-SemiBoldItalic.ffaf7dca.woff2";